import { useQuery } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';
import { config } from '@services/config';
import { PostRateDefaultFactorTypeSearchRequestQuery, PostRateDefaultFactorTypeSearchResponse } from '@lio/api-types';
import { postRateDefaultFactorTypeKeys } from './keys';

const getQuery = (params: PostRateDefaultFactorTypeSearchRequestQuery) => {
  const query = new URLSearchParams();
  if (params?.codeName) query.append('codeName', params.codeName);
  if (params?.label) query.append('label', params.label);
  if (params?.sort) query.append('sort', params.sort);
  if (params?.pageLimit) query.append('pageLimit', params.pageLimit.toString());
  if (params?.pageOffset !== undefined) query.append('pageOffset', params.pageOffset.toString());
  return query.toString();
};

export const useSearchPostRateDefaultFactorTypes = (params: PostRateDefaultFactorTypeSearchRequestQuery = {}) => {
  const client = useClient();
  const queryParams = getQuery({ ...params, pageLimit: params.pageLimit ?? 100 });

  const result = useQuery<PostRateDefaultFactorTypeSearchResponse, Error>({
    queryKey: postRateDefaultFactorTypeKeys.searchWithParams(params),
    queryFn: () =>
      client.get(`post-rate-default-factor-type?${queryParams}`).json<PostRateDefaultFactorTypeSearchResponse>(),
    ...config,
  });

  return { ...result, items: result.data?.items ?? [] };
};
